<template>
  <div>
    <!-- 图片上传组件 -->
    <a-upload
      accept=".jpg, .jpeg, .png"
      :file-list="fileList"
      name="avatar"
      list-type="picture-card"
      class="avatar-uploader"
      :beforeUpload="beforeUpload"
      @preview="handlePreview"
      :customRequest="customRequest"
      :disabled="disabled"
      :remove="removeImg"
    >
      <div v-if="fileList.length < 1">
        <plus-outlined />
        <div style="margin-top: 8px">上传图片</div>
      </div>
    </a-upload>

    <!-- 放大查看图片 -->
    <el-dialog 
      :title="previewImage.previewTitle" 
      :visible.sync="previewImage.previewVisible" 
      :modal-append-to-body="false"
      :append-to-body="true"
      class="imgPreviewDialog"
      @cancel="previewImage.previewVisible = false">
      <img alt="example" style="width: 100%" :src="imgUrl" class="previewImg"/>
    </el-dialog>
  </div>
</template>
<script>
import * as API_Member from "@/api/member/member";
export default {
  data() {
    return {
      fileList: [],
      disabled: false,
      imgUrl: undefined,
      previewImage: {
        previewVisible: false,
        previewTitle: "图片预览",
      },
    };
  },
  props: {
    ImgUrl: {
      type: String,
      default: undefined,
    },
    //图片类型1资源图片2用户头像3营业执照图片
    ImgType: {
      type: Number,
      default: 1,
    },
    Disabled: {
      type: Boolean,
      default: false,
    },
    Index: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    ImgUrl(newV) {
      console.log(newV);
      this.imgUrl = newV;
      if(newV) {
        this.fileList = [
          {
            uid: "-1",
            name: "image.png",
            status: "done",
            url: newV,
          },
        ];
      } else {
        this.fileList = []
      }
    },
  },
  mounted() {
    let _that = this;
    let url = _that.ImgUrl;
    _that.fileList = [
      {
        uid: "-1",
        name: "image.png",
        status: "done",
        url: url,
      },
    ];
    _that.imgUrl = url;
    _that.disabled = _that.Disabled;
    if (_that.disabled && (url == undefined || url == null || url.length < 1)) {
      _that.fileList[0].name = "无效图片";
    } else if (url == undefined || url == null || url.length < 1) {
      // _that.fileList[0].name = "无效图片";
      _that.fileList = [];
    }
  },
  methods: {
    //图片上传规则
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.fileList = [];
        this.$message.error("只能上传JPG/PNG 图片，请重新选择!");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片不能超过 2MB!");
        return false;
      }
      this.customRequest(file);
      return false;
    },
    //图片上传
    customRequest(file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", this.ImgType); //随便写一个token示例this.saveFile(formData)
      API_Member.uploadOss(formData).then((res) => {
        if (res.code == 0 || res.code == 200) {
          this.fileList = [
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: res.data.url,
              // url: res.data,
            },
          ];
          this.imgUrl = res.data.url;
          // this.imgUrl = res.data;
          this.$emit("imgCallback", res.data.url, this.Index);
        }
      });
      //   this.$axios.post("/api/file/uploadOss", formData).then((res) => {
      //     // this.$axios.post("/api/v1/file/upload/image", formData).then((res) => {
      //     if (res.code == 0 || res.code == 200) {
      //       this.fileList = [
      //         {
      //           uid: "-1",
      //           name: "image.png",
      //           status: "done",
      //           url: res.data.url,
      //           // url: res.data,
      //         },
      //       ];
      //       this.imgUrl = res.data.url;
      //       // this.imgUrl = res.data;
      //       this.$emit("imgCallback", res.data.url, this.Index);
      //     }
      //   });
    },
    //删除图片
    removeImg(file) {
      this.fileList = [];
      this.$emit("imgCallback", "", this.Index);
    },
    //预览
    handlePreview(file) {
      this.previewImage.previewVisible = true;
    },
    //以下方法为图片转换(备份)
    imgChange(file) {
      String.prototype.replaceAll = function (s1, s2) {
        return this.replace(new RegExp(s1, "gm"), s2);
      };
      this.getBase64(file).then((el) => {
        //this.athletForm.imageUrl = el; //图片转base64
        this.$message.info("图片获取成功");
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    //base64转图片
    base64ImgtoFile(dataurl, filename = "file") {
      dataurl = localStorage.getItem("img");
      if (dataurl) {
        this.athletForm.imageUrl = dataurl;
        let index = this.genId(5);
        return {
          uid: index,
          name: "运动员图像信息",
          status: "done",
          url: dataurl,
        };
      }
      return null;
    },
    genId(length) {
      return Number(
        Math.random().toString().substr(3, length) + Date.now(),
      ).toString(36);
    },
  },
};
</script>
<style lang="less">
  .imgPreviewDialog .el-dialog__body {
    max-height: 75vh;
    overflow-y: auto;
  }
</style>